import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
//import { useMediaQuery } from 'react-responsive';

import PrivateRoute from './components/VerificaSessao/VerificaSessao';
import Home from './pages/homePage/HomePage';
import ListaSap from './pages/listaSapPage/ListaSap';
import User from './pages/userPage/UserPage';
import ServidoresCmd from './pages/servidoresCmdPage/ServidoresCmd';
import CondominioPage from './pages/condominioPage/CondominioPage';


function App() {
  //const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <Router>
      <Routes>
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />

        <Route
          path="/listaSap"
          element={
            <PrivateRoute>
              <ListaSap />
            </PrivateRoute>
          }
        />

        <Route
          path="/user"
          element={
            <PrivateRoute>
              <User />
            </PrivateRoute>
          }
        />

        <Route
          path="/servidores"
          element={
            <PrivateRoute>
              <ServidoresCmd />
            </PrivateRoute>
          }
        />

        <Route
          path="/condominios"
          element={
            <PrivateRoute>
              <CondominioPage />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
